import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import logo from '../../logo.png'
import { useNavigate } from 'react-router-dom'
import { currentUser } from '../../lib/auth'
import { useLoginUser } from '../../hooks/db/useLogin'
import { useAddUserActivity } from '../../hooks/db/useAddUserActivity'

const Login: React.FC = () => {
    const { loginUser } = useLoginUser()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const navigate = useNavigate()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { addUserActivity } = useAddUserActivity()

    const handleSubmit = async (e: React.FormEvent) => {
            e.preventDefault();
            setIsSubmitting(true)
            try {
                const result = await loginUser({
                    email: email,
                    password: password,
                });
                
                if (result.success) {
                    localStorage.setItem('authToken', result.token)
                    
                    toast.success(result.message, {
                        position: "top-center",
                    })
                    
                    const user = currentUser()

                    // Log user activity
                    await addUserActivity('LOGIN', {role: user.role ?? 'USER'})

                    if (user && user.role === 'ADMIN') {
                        setTimeout(() => {
                            navigate('/dashboard')
                        },1000)
                    }else{ 
                        setTimeout(() => {
                            navigate('/research') // or default route
                        }, 1000)
                    }
                } else {
                    console.log("Login Failed: ", "Invalid email or password");
                    toast.error("Invalid email or password", {
                        position: "bottom-center",
                    });
                    setPassword("")
                    return;
                }

            } catch (error) {
                if (error instanceof Error) {
                    console.log(error.message);
                    toast.error(error.message, {
                        position: "bottom-center",
                    });
                    setPassword("")
                } else {
                    console.log("An unknown error occurred");
                }
                
            }finally {
                setIsSubmitting(false)
            }
        }

        useEffect(() => {
            const user = currentUser();
            if (user) {
                if (user.role === 'ADMIN') {
                    navigate('/dashboard')
                } else {
                    navigate('/research')
                }
            }
        }, [navigate])
    

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4 sm:px-6 lg:px-8">
            <ToastContainer />
            <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-lg">
                {/* <h1 className="text-3xl font-bold text-center mb-4">AdeptGroup</h1> */}
                
                <div className="flex justify-center mb-4">
                    <img src={logo} alt="Company Logo" className="h-18" />
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                    
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                        placeholder='Email'
                    />
                    </div>
                    <div className="mb-4">
                    
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                        placeholder='Password'
                    />
                    </div>
                    
                    <div className="mb-4 flex justify-center">
                        <input
                            type="checkbox"
                            id="terms"
                            className="mr-2"
                            required
                        />
                        <label htmlFor="terms" className="text-sm text-gray-700">
                            I agree to the{' '}
                            <a
                                href="/terms"
                                className="text-blue-500 hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms and Conditions
                            </a>
                            &nbsp;and&nbsp;
                            <a
                                href="/user-agreements"
                                className="text-blue-500 hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                User Agreement
                            </a>
                            
                        </label>
                    </div>

                    <button
                    type="submit"
                    className="loginBtn btnLong w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300"
                    disabled={isSubmitting}
                    >
                    {isSubmitting ? 'Logging in...' : 'Login'}
                    </button>
                </form>
                <div className="mt-4 text-center">
                    <a
                        href="/forgot-password"
                        className="text-sm text-blue-500 hover:underline"
                    >
                        Forgot Password?
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Login
